// removed by extract-text-webpack-plugin
module.exports = {"select":"hk-select-select"};